import { useSelector } from "react-redux";

import { ComponentHistoryRedeem } from "@components";
import { selectAuth } from "@redux";

export const PageHistoryRedeem = () => {
    //redux states
    const { userInfo } = useSelector(selectAuth);

    //variable
    const memberTier = userInfo?.memberTier;

    return (
        <ComponentHistoryRedeem
            memberTier={memberTier} avatar={""} fullName={""} />
    );
};
